<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الاسم:</label>
            <div>{{ dataRow.User.name }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الجوال:</label>
            <div>{{ dataRow.User.mobile }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">التاريخ:</label>
            <div>{{ dataRow.date }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الوقت:</label>
            <div>{{ dataRow.time }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع المعاينة:</label>
            <div>{{ (dataRow.fancyReview)? 'فاخرة' : 'عادية' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تم السداد:</label>
            <div>{{ (dataRow.isPaid)? 'تم السداد' : 'لم يسدد' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">العقار:</label>
            <div>
              <router-link v-if="dataRow.Property" :to="`/properties/update/${dataRow.Property.id}`">{{ dataRow.Property.title }}</router-link>
              <router-link v-if="dataRow.Exchange" :to="`/exchanges/update/${dataRow.Exchange.id}`">{{ dataRow.Exchange.name }}</router-link>
            </div>
          </div>
          <div v-if="parseFloat(dataRow.latitude) || parseFloat(dataRow.longitude)" class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">موقع العميل:</label>
            <div class="mb-2">
              <a :href="`https://www.google.com/maps?q=${dataRow.latitude},${dataRow.longitude}`" target="_blank">{{ `https://www.google.com/maps?q=${dataRow.latitude},${dataRow.longitude}` }}</a>
            </div>
            <div>{{ dataRow.address }}</div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الطلب:</label>
            <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الطلب:</label>
            <select v-model="status" class="form-control">
              <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
            </select>
          </div> 
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مصدر الطلب:</label>
            <div>
              <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
              <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
              <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
              <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
              <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
              <span v-else class="text-muted">غير محدد</span>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';

export default {
  name: 'ReservationsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
      adminNotice: null,
    }
  },
  methods: {
    formatDate,
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/reservations/update/${this.dataRow.id}`, {
          status: this.status,
          adminNotice: this.adminNotice,
        });
      else
        return false;
        // api = this.$http.post('/api/admin/properties/create', formData);
      api.then(({data}) => {
        if(false){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyDoc').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
      this.adminNotice = this.dataRow.adminNotice;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
